import { Component, Inject, Input } from '@angular/core';
import { L10n, L10nBase } from '@skylab-angular-shared/core';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { withModule } from '@skylab-shared/business';
import { CalculationMethod } from '@skylab-shared/dataModel';
import { isUndefined } from '@skylab-shared/utils';

@Component({
    selector: 'skl-product-quick-list-header',
    template: `
        <div class="item-wrapper header">
            <div class="item item--star">
            </div>
            <div class="item item--name">
                {{'shared.scenes.product-quick-list-item.name.label' | translate}}
            </div>
            <div class="item item--price">
                {{priceLabel}}
            </div>
            @if (isInventoryLevelVisible) {
                <div class="item item--level">
                    {{'shared.scenes.product-quick-list-item.level.label' | translate}}
                </div>
            }
        </div>
    `,
    styleUrls: ['./product-quick-list-item.component.scss'],
    styles: [`
        .header {
            padding: var(--gutter-medium);
            border-bottom: 1px solid var(--line-1-color);
        }
    `],
    imports: [TranslatePipe]
})
export class ProductQuickListHeaderComponent {
    @Input() public vatPayer!: boolean;
    @Input() public calculationMethod!: CalculationMethod;

    public constructor(
        @Inject(L10n) private readonly l10n: L10nBase
    ) { }

    public get isInventoryLevelVisible(): boolean {
        return withModule('Inventory');
    }

    public get priceLabel(): string {
        if (!isUndefined(this.vatPayer) && !this.vatPayer) return this.l10n._T('shared.scenes.product-quick-list-item.price.label');
        if ([CalculationMethod.Net, CalculationMethod.Manual].includes(this.calculationMethod)) return this.l10n._T('shared.scenes.product-quick-list-item.price-net.label');

        return this.l10n._T('shared.scenes.product-quick-list-item.price-gross.label');
    }
}
